import { Box, Text } from '@usealloy/component-library';
import styled, { css } from 'styled-components';

export const StyledDataRoutingFormContainer = styled(Box)`
  &&& {
    flex-direction: column;
    align-items: stretch;
    overflow-x: auto;
    padding: var(--cl-space-5) var(--cl-space-6);
    gap: var(--cl-space-6);
  }
`;

export const StyledDataRoutingColumns = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
  gap: var(--cl-space-14);
`;

export const StyledLeftColumnContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-basis: 44%;
  gap: var(--cl-space-4);
`;

export const StyledRightColumnContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-basis: 47%;
  gap: var(--cl-space-4);
`;

export const StyledSpacer = styled.div`
  flex-grow: 1;
`;

export const StyledCategoryContainer = styled.div`
  display: grid;
  border: 1px solid var(--cl-gray-300);
  border-radius: var(--cl-radius-2);
  padding: var(--cl-space-4);
  grid-template-columns: 1fr 1fr auto;
  column-gap: var(--cl-space-4);
`;

export const StyledDeactivatedCategoryContainer = styled(StyledCategoryContainer)`
  background-color: var(--cl-gray-400);
  border-color: transparent;
`;

export const CategoryInfo = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: var(--cl-space-1);
  min-width: 0;
`;

export const StyledPre = styled.pre`
  font-family: var(--cl-font-family-mono);
  font-size: var(--cl-font-size-2);
  font-weight: var(--cl-font-weight-regular);
  margin-bottom: 0;
  margin-top: 0;
  flex-shrink: 0;
`;

export const StyledRoutingServiceName = styled(StyledPre)<{
  serviceSelected: boolean;
}>`
  color: ${({ serviceSelected }) => (serviceSelected ? 'var(--cl-green-500)' : 'var(--cl-text-default)')};
`;

const truncateText = css`
  min-width: 0;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const StyledLockedRouteValue = styled(StyledPre)`
  font-weight: var(--cl-font-weight-bold);
  line-height: var(--cl-line-height-4);
  ${truncateText}
`;

export const RouteActions = styled.div`
  display: flex;
  gap: var(--cl-space-3);
`;

export const StyledDynamicRoutesInfoBanner = styled.div`
  display: flex;
  align-items: center;
  gap: var(--cl-space-1);
`;

export const StyledDynamicRoutesInfoBannerText = styled(Text)`
  &&& {
    color: var(--cl-text-secondary);
    font-feature-settings: 'liga' off, 'clig' off;
    font-family: var(--cl-font-family-default);
    font-size: var(--cl-font-size-1);
    font-style: normal;
    font-weight: var(--cl-font-weight-regular);
    line-height: var(--cl-line-height-1);
  }
`;

export const dynamicRouteChipTokens = {
  backgroundColor: 'var(--cl-yellow-200)',
  borderRadius: 'var(--cl-radius-1)',
  padding: '0 var(--cl-space-1)',
  fontFamily: 'var(--cl-font-family-mono)',
  fontSize: '14px',
  fontWeight: 'var(--cl-font-weight-bold)',
  lineHeight: '24px',
  color: 'var(--cl-text-default)',
} as const;

export const StyledDynamicRouteChip = styled.span`
  display: inline-flex;
  align-items: center;
  width: fit-content;
  cursor: pointer;
  background-color: ${dynamicRouteChipTokens.backgroundColor};
  border-radius: ${dynamicRouteChipTokens.borderRadius};
  padding: ${dynamicRouteChipTokens.padding};
  font-family: ${dynamicRouteChipTokens.fontFamily};
  font-size: ${dynamicRouteChipTokens.fontSize};
  font-weight: ${dynamicRouteChipTokens.fontWeight};
  line-height: ${dynamicRouteChipTokens.lineHeight};
  color: ${dynamicRouteChipTokens.color};
`;

